<template>
  <div class="wrapper">
    <div class="login-card">
      <div class="login-card-header">
        <img
          :src="require(`@/assets/logos/fevercoloridosf.png`)"
          alt="pickndrive"
          style="width: 320px;"
        />
      </div>
      <h3 class="title">
        Defina sua nova senha:
      </h3>
      <form @submit.prevent="changePassword">
        <div class="form-group">
          <label for="password-input">Senha</label>
          <input
            type="password"
            v-model="password"
            id="password-input"
            class="form-control"
            placeholder="Sua nova senha"
            aria-label="Sua nova senha"
            aria-describedby="basic-addon2"
          />
        </div>
        <div class="form-group">
          <label for="confirmPassword-input">Confirmar Senha</label>
          <input
            type="password"
            v-model="confirmPassword"
            id="confirmPassword-input"
            class="form-control"
            placeholder="Confirme sua senha"
            aria-label="Confirme sua senha"
            aria-describedby="basic-addon2"
          />
        </div>
        <button type="submit" class="btn btn-block">Confirmar</button>
      </form>
    </div>
    <div class="footer">
      <img
        :src="require(`@/assets/logos/ftrackcolorido.png`)"
        alt="pickndrive"
        style="width: 320px;"
      />
    </div>
  </div>
</template>

<script>
import AuthController from '../../controllers/AuthController.js';

export default {
  data() {
    return {
      email: null,
      password: null,
      confirmPassword: null,
    };
  },

  created() {
    this.authController = new AuthController(
      this.$resource,
      this.$router,
      this.$message
    );
    const email = this.$route.params.email;
    const token = this.$route.params.token;

    this.authController.accessResetPassword(email, token);
  },

  methods: {
    changePassword() {
      if (this.password === this.confirmPassword) {
        this.authController.changePassword(this.password).then(() => {
          this.$message({
            message: 'Senha alterada com sucesso!',
            type: 'success',
          });
          setTimeout(() => {
            window.location.href = 'http://fever.usecargoapp.mobi/';
          }, 2000);
        });
      } else {
        this.$message({
          message: 'As senhas informadas não são iguais!',
          type: 'error',
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
label {
  margin: 0;
  padding: 0;
  color: #002153;
}
.wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(180deg, #f9f9f9 0.06%, #898a8d 377.93%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper .login-card {
  border-radius: 3px;
  padding: 15px 25px 300px;
  width: 400px;
  @media (max-width: 600px) {
    width: 80%;
  }
}

.login-card .change-visibility-span:hover {
  cursor: pointer;
}

.forgot-password {
  display: flex;
  justify-content: flex-end;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 400px;
  width: 100vw;
  background-color: #002153;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn {
  background: #ff7300 !important;
  color: #36292c;
  font-weight: bold;
  border-radius: 0;
  margin-top: 30px;
}
.title {
  color: #002153;
  margin-top: 10%;
  text-align: center;
}
.login-card-header {
  text-align: center;
}
</style>
